import React, { FunctionComponent, useEffect, useState } from 'react'
import EatalyLogoContainer, {
  eatalySmallSnowflake,
} from './EatalyLogoContainer'
import { TSUtils } from '../../utils/TSUtils'
import moment from 'moment-timezone'

interface Props {
  onClick: (day: number) => void
}

const PADDING = 15
const today = moment()

const EatalyAdventCalendar: FunctionComponent<Props> = (props) => {
  const [days, setDays] = useState<number[]>([])
  const [itemWidth, setItemWidth] = useState<number>(0)
  const [circleDimension, setCircleDimension] = useState<number>(0)
  const [snowflakeDimension, setSnowflakeDimension] = useState<number>(0)

  useEffect(() => {
    const days: number[] = []

    for (let idx = 1; idx <= 24; idx++) {
      days.push(idx)
    }

    const itemWidth = Math.trunc((window.innerWidth - 2 * PADDING) / 4)
    const circleDimension = Math.trunc(itemWidth * 0.5)
    const snowflakeDimension = Math.trunc(circleDimension / 3)

    setDays(TSUtils.shuffleArray(days))
    setItemWidth(itemWidth)
    setCircleDimension(circleDimension)
    setSnowflakeDimension(snowflakeDimension)
  }, [])

  return (
    <>
      <EatalyLogoContainer
        text="Ouvrez la case du jour !"
        smallTopContainer={true}
        displaySnowflakesForSubtitle={true}
      />

      <div className="eat-advent-container cm-pad">
        {days.map((day) => {
          const blink = day === today.date()
          return (
            <div
              key={`adv-${day}`}
              className="eat-adv-item"
              style={{ width: itemWidth }}
            >
              <div
                className="eat-adv-item-circle"
                style={{ height: circleDimension, width: circleDimension }}
                onClick={() => props.onClick(day)}
              >
                <span className={blink ? 'advent-blink' : ''}>{day}</span>
              </div>
              <div
                className="eat-adv-item-sf"
                style={{ height: snowflakeDimension }}
              >
                <img
                  className="eat-adv-item-img"
                  src={eatalySmallSnowflake}
                  style={{
                    height: snowflakeDimension,
                    width: snowflakeDimension,
                  }}
                  alt={'snowflake'}
                />
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default EatalyAdventCalendar
